var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7B4039CA-B2FE-40D3-ACEC-2070C8BC85BE@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.75,9 C11.8210678,9 13.5,10.6789322 13.5,12.75 L13.5,14.25 C13.5,14.6642136 13.1642136,15 12.75,15 C12.3357864,15 12,14.6642136 12,14.25 L12,12.75 C12,11.5073593 10.9926407,10.5 9.75,10.5 L3.75,10.5 C2.50735931,10.5 1.5,11.5073593 1.5,12.75 L1.5,14.25 C1.5,14.6642136 1.16421356,15 0.75,15 C0.335786438,15 0,14.6642136 0,14.25 L0,12.75 C0,10.6789322 1.67893219,9 3.75,9 Z M6.75,0 C8.82106781,0 10.5,1.67893219 10.5,3.75 C10.5,5.82106781 8.82106781,7.5 6.75,7.5 C4.67893219,7.5 3,5.82106781 3,3.75 C3,1.67893219 4.67893219,0 6.75,0 Z M6.75,1.5 C5.50735931,1.5 4.5,2.50735931 4.5,3.75 C4.5,4.99264069 5.50735931,6 6.75,6 C7.99264069,6 9,4.99264069 9,3.75 C9,2.50735931 7.99264069,1.5 6.75,1.5 Z",
    id: "path-1-user"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_interactions",
    transform: "translate(-173.000000, -723.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(139.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(12.757058, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/user-Copy-7",
    transform: "translate(21.492942, 134.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "FFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-user"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "FFF",
    xlinkHref: "#path-1-user"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b9a9ac878f5a6c00c370a0f3973a7a6f.svg";
export { ForwardRef as ReactComponent };